import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Youtube, Hash } from 'lucide-react';
const popularTags = [{
  tag: 'CoffeeExport',
  link: '/trade-data'
}, {
  tag: 'LivestockVaccines',
  link: '/about/animal-resources'
}, {
  tag: 'Irrigation',
  link: '/about/extension-services'
}, {
  tag: 'Agrobusiness',
  link: '/opportunities'
}, {
  tag: 'AgroProcessing',
  link: '/guidelines-services'
}, {
  tag: 'SeedCertification',
  link: '/guidelines-services'
}];
export function Footer() {
  return <footer className="bg-uganda-green text-white pt-16 pb-8" data-id="element-85">
      <div className="max-w-[1300px] mx-auto px-4 md:px-8" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12" data-id="element-87">
          {/* Column 1: Contact */}
          <div className="lg:col-span-1" data-id="element-88">
            <Link to="/" className="flex items-center space-x-3 mb-6" data-id="element-89">
              <div className="w-10 h-10 flex items-center justify-center" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/ncbNXNqcQkdode5pLbsA1p/Coat_of_arms_of_Uganda.svg_(1).png" alt="Uganda Coat of Arms" className="w-10 h-10 object-contain" data-id="element-91" />
              </div>
              <div className="flex flex-col" data-id="element-92">
                <span className="font-bold text-sm leading-tight" data-id="element-93">MAAIF</span>
                <span className="text-xs text-green-200 leading-tight" data-id="element-94">
                  Entebbe, Uganda
                </span>
              </div>
            </Link>
            <ul className="space-y-3 text-sm text-gray-200" data-id="element-95">
              <li className="flex items-start" data-id="element-96">
                <MapPin className="w-4 h-4 mr-2 text-uganda-yellow shrink-0 mt-0.5" data-id="element-97" />
                <span data-id="element-98">
                  Plot 16-18 Lugard Avenue, P.O. Box 102, Entebbe, Uganda
                </span>
              </li>
              <li className="flex items-center" data-id="element-99">
                <Phone className="w-4 h-4 mr-2 text-uganda-yellow shrink-0" data-id="element-100" />
                <span data-id="element-101">Toll-Free: 0800 100 987</span>
              </li>
              <li className="flex items-center" data-id="element-102">
                <Phone className="w-4 h-4 mr-2 text-uganda-yellow shrink-0" data-id="element-103" />
                <span data-id="element-104">041 4320004</span>
              </li>
              <li className="flex items-center" data-id="element-105">
                <Mail className="w-4 h-4 mr-2 text-uganda-yellow shrink-0" data-id="element-106" />
                <span data-id="element-107">info@agriculture.go.ug</span>
              </li>
            </ul>
            <div className="flex space-x-3 mt-5" data-id="element-108">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-uganda-yellow hover:text-uganda-black transition-colors" title="Facebook" data-id="element-109">
                <Facebook className="w-4 h-4" data-id="element-110" />
              </a>
              <a href="https://twitter.com/ABORIGEN_MAAIF" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-uganda-yellow hover:text-uganda-black transition-colors" title="@MAAIF_Uganda" data-id="element-111">
                <Twitter className="w-4 h-4" data-id="element-112" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-uganda-yellow hover:text-uganda-black transition-colors" title="LinkedIn" data-id="element-113">
                <Linkedin className="w-4 h-4" data-id="element-114" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-uganda-yellow hover:text-uganda-black transition-colors" title="YouTube" data-id="element-115">
                <Youtube className="w-4 h-4" data-id="element-116" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-117">
            <h3 className="text-sm font-bold mb-5 text-uganda-yellow uppercase tracking-wider" data-id="element-118">
              Quick Links
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-200" data-id="element-119">
              <li data-id="element-120">
                <Link to="/opportunities" className="hover:text-white transition-colors" data-id="element-121">
                  Job Vacancies
                </Link>
              </li>
              <li data-id="element-122">
                <Link to="/opportunities" className="hover:text-white transition-colors" data-id="element-123">
                  Tenders & Bidding Notices
                </Link>
              </li>
              <li data-id="element-124">
                <Link to="/applications" className="hover:text-white transition-colors" data-id="element-125">
                  Services & Portals
                </Link>
              </li>
              <li data-id="element-126">
                <Link to="/media" className="hover:text-white transition-colors" data-id="element-127">
                  News & Events
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="/about/vision-mission" className="hover:text-white transition-colors" data-id="element-129">
                  About MAAIF
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-131">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Affiliated Agencies */}
          <div data-id="element-132">
            <h3 className="text-sm font-bold mb-5 text-uganda-yellow uppercase tracking-wider" data-id="element-133">
              Affiliated Agencies
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-200" data-id="element-134">
              <li data-id="element-135">
                <Link to="/agencies" className="hover:text-white transition-colors" data-id="element-136">
                  NARO — National Agric. Research Org.
                </Link>
              </li>
              <li data-id="element-137">
                <Link to="/agencies" className="hover:text-white transition-colors" data-id="element-138">
                  UCDA — Uganda Coffee Dev. Authority
                </Link>
              </li>
              <li data-id="element-139">
                <Link to="/agencies" className="hover:text-white transition-colors" data-id="element-140">
                  DDA — Dairy Development Authority
                </Link>
              </li>
              <li data-id="element-141">
                <Link to="/agencies" className="hover:text-white transition-colors" data-id="element-142">
                  CDO — Cotton Development Org.
                </Link>
              </li>
              <li data-id="element-143">
                <Link to="/agencies" className="hover:text-white transition-colors" data-id="element-144">
                  NAGRC&DB — National Animal Genetic Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal */}
          <div data-id="element-145">
            <h3 className="text-sm font-bold mb-5 text-uganda-yellow uppercase tracking-wider" data-id="element-146">
              Legal
            </h3>
            <ul className="space-y-2.5 text-sm text-gray-200" data-id="element-147">
              <li data-id="element-148">
                <Link to="/resources" className="hover:text-white transition-colors" data-id="element-149">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-150">
                <Link to="/resources" className="hover:text-white transition-colors" data-id="element-151">
                  Terms of Use
                </Link>
              </li>
              <li data-id="element-152">
                <Link to="/resources" className="hover:text-white transition-colors" data-id="element-153">
                  Access to Information Act
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-155">
                  Accessibility Statement
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/" className="hover:text-white transition-colors" data-id="element-157">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5: Popular Tags */}
          <div data-id="element-158">
            <h3 className="text-sm font-bold mb-5 text-uganda-yellow uppercase tracking-wider" data-id="element-159">
              Popular Tags
            </h3>
            <div className="flex flex-wrap gap-2" data-id="element-160">
              {popularTags.map(({
              tag,
              link
            }) => <Link key={tag} to={link} className="inline-flex items-center bg-white/10 hover:bg-uganda-yellow hover:text-uganda-black text-xs font-medium px-3 py-1.5 rounded-full transition-colors border border-white/10 hover:border-uganda-yellow" data-id="element-161">
                  <Hash className="w-3 h-3 mr-1" data-id="element-162" />
                  {tag}
                </Link>)}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center text-xs text-gray-300" data-id="element-163">
          <div className="mb-4 md:mb-0" data-id="element-164">
            &copy; {new Date().getFullYear()} Ministry of Agriculture, Animal
            Industry and Fisheries. All rights reserved.
          </div>
          <div className="flex space-x-6" data-id="element-165">
            <Link to="/resources" className="hover:text-white transition-colors" data-id="element-166">
              Privacy Policy
            </Link>
            <Link to="/resources" className="hover:text-white transition-colors" data-id="element-167">
              Terms of Use
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors" data-id="element-168">
              Accessibility
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Flag Stripe */}
      <div className="h-1.5 w-full flex mt-8" data-id="element-169">
        <div className="h-full w-1/3 bg-black" data-id="element-170"></div>
        <div className="h-full w-1/3 bg-uganda-yellow" data-id="element-171"></div>
        <div className="h-full w-1/3 bg-uganda-red" data-id="element-172"></div>
      </div>
    </footer>;
}